import Modal from "react-bootstrap/Modal";
import React, {useEffect, useState} from "react";
import API from "../../apiService";
import moment from "moment";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";

const ModalDetail = ({show, onHide, lab, patient_id}) => {

    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState([])

    useEffect(() => {
        if (patient_id && lab) {
            getHistory()
        }
    }, [JSON.stringify(lab)])

    const getHistory = async () => {
        setIsLoading(true)
        const res = await API.get(`registration/lab/detail_history?patient_id=${patient_id}&lab_detail_id=${lab.id}`)
        if (res.code === 200) {
            setData(res.data)
        }
        else {
            setData([])
        }
        setIsLoading(false)
    }

    return (
        <Modal
            show={ show }
            onHide={() => {
                onHide()
                setData([])
            }}
            centered>
            <Modal.Body className={'pb-0'}>
                <h4 className={'mb-0'}>History {lab?.name ?? ''}</h4>
            </Modal.Body>
            <Modal.Body>
                {isLoading ? 'Memuat data...' : (lab?.value_type === 'angka' ? <BarChart data={data} lab={lab}/> : data.map((v, k) => <HistoryItem v={v} k={k} lab={lab}/>))}
            </Modal.Body>
            <Modal.Footer className={'pt-0'}>
                <button type={'button'} className={'btn btn-danger'} onClick={onHide}>
                    Tutup
                </button>
            </Modal.Footer>
        </Modal>
    )
}

const HistoryItem = ({v, k, lab}) => (
    <li
        className='checklist-entry list-group-item align-items-start'
        key={`h-${k}`}>
        <div className='d-flex w-100 justify-content-between'>
            <div>
                <div className='d-flex w-100 align-items-center'>
                    <h3 className='mb-1'>{v.user.name}</h3>
                </div>
            </div>
            <small>
                {moment(v.created_at).format("DD-MM-YYYY HH:mm:ss")}
            </small>
        </div>
        <div className='row h4'>
            <div className='col-4'>Pemeriksaan</div>
            <div className='col-8'>
                : <mark>{lab?.name ?? ''}</mark>
            </div>
            <div className='col-4'>Hasil</div>
            <div className='col-8'>
                :{" "}
                <mark>
                    {v.result ? v.result + " " + (lab?.unit ?? '') : "-"}
                </mark>
            </div>
        </div>
    </li>
)

const BarChart = ({data, lab}) => {
    const options = {
        title: {
            text: lab?.name ?? ''
        },
        xAxis: {
            categories: data.map(v => moment(v.created_at).format("DD-MM-YYYY HH:mm:ss")),
        },
        yAxis: {
            title: false,
            // tickAmount: 3
        },
        legend: {
            enabled: false
        },
        tooltip: {
            formatter: function () {
                return `<b>${this.x}<br>${this.y} ${lab?.unit ?? ''}</b>`
            }
        },
        plotOptions: {
            column: {
                pointWidth: 16
            },
            series: {
                borderRadius: 5
            }
        },
        chart: {
            height: '50%',
        },
        series: [{
            type: 'column',
            styledMode: true,
            data: data.map(v => +v.result || 0)
        }]
    }

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />
    )
}

export default ModalDetail